import React, { Fragment, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { ModalFooter } from "react-bootstrap";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useEffect } from "react";
import { getPlanDataById, getPolicyDetailsById } from "../../../api";
import { getProductById } from "../../../api";
import Information from "../policies/view-policy-details/modal-components/information";
import Validity from "../policies/view-policy-details/modal-components/validity";
import Fees from "../policies/view-policy-details/modal-components/fees";
import Cost from "../policies/view-policy-details/modal-components/cost";
import ServiceInformation from "../policies/view-policy-details/modal-components/service-infornation";
import MedicalCover from "../policies/view-policy-details/modal-components/medical-cover";
import Insurance from "../policies/view-policy-details/modal-components/insurance";
import Assistance from "../policies/view-policy-details/modal-components/service-infornation";
import AddonDetails from  "../policies/view-policy-details/modal-components/addon-deatils";

const ViewProductModal = (props) => {
    const { isOpen , toggle, selectedProductData} = props;
    const [viewPolicyDetailsByType, setViewPolicyDetailsByType] = useState(0);
    const [productDataById, setProductDataById] = useState({});
    const steps = [
        { key: 0, name: 'Information', component: <Information data={productDataById} selectedProductData={selectedProductData}/> },
        { key: 1, name: 'Medical Cover', component: <MedicalCover data={productDataById}/> },
        { key: 2, name: 'Insurance', component: <Insurance data={productDataById}/> },
        { key: 3, name: 'Assistance', component: <Assistance data={productDataById}/> },
        { key: 4, name: 'Addons', component: <AddonDetails data={productDataById}/> },

        // { key: 4, name: 'Cost', component: <Cost data={productDataById}/> },
        // { key: 5, name: 'Validity (in Days)', component: <Validity data={productDataById} /> }
    ]

    const handleNextTabByClick = (nextStepValue, steps) => {
        if (nextStepValue < steps.length) {
            // console.log(viewPolicyDetailsByType, 'viewPolicyDetailsByType');
            setViewPolicyDetailsByType(viewPolicyDetailsByType + 1);
        }
    }

    const handlePreviousTabByClick = (previousStepValue, steps) => {
        if (previousStepValue >= 0) {
            setViewPolicyDetailsByType(viewPolicyDetailsByType - 1);
        }
    }

    const getProductData = async () => {
        try {
        //   setIsLoading(true);
          const product_id = selectedProductData.id;
          const data = await getPlanDataById(product_id);
          setProductDataById(data.data?.result);
          
        //   setCount(data.data?.result?.totalCount);
        //   setIsLoading(false);
    
        } catch (error) {
          console.log("Error:", error);
        }
      };

      useEffect(() => {
        getProductData();
      }, []);


    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} size="lg"   backdrop="static">
                <ModalHeader toggle={toggle} className="pb-0 border-0">
                    {"Product Details"}
                </ModalHeader>
                <ModalBody className="pt-4">
                    <Nav className="nav-pills nav-justified">
                        {
                            steps && steps.map((item, i) => {
                                return (
                                    <NavItem key={i}>
                                        <NavLink href="#javascript" className={viewPolicyDetailsByType === item.key ? 'active' : ''} onClick={() => setViewPolicyDetailsByType(item.key)}>
                                            <span style={{ whiteSpace: 'nowrap' }}> {item.name} </span>
                                        </NavLink>
                                    </NavItem>
                                )
                            })
                        }
                    </Nav>
                    <TabContent activeTab={viewPolicyDetailsByType}>
                        {
                            steps && steps.map((item, i) => {
                                return (
                                    <TabPane className={item.key === 0 ? "fade show" : ""} tabId={item.key} key={i}>
                                        {item.component}
                                    </TabPane>
                                )
                            })
                        }
                    </TabContent>
                </ModalBody>
                <ModalFooter>
                    <div className="container-fluid">
                        <div className="row">
                        <div className="col-6">
                        {parseInt(viewPolicyDetailsByType) !== 0 && (
                            <Button
                            className="mr-2 btnCustom"
                            outline
                            color="info"
                            size="md"
                            onClick={(e) => handlePreviousTabByClick(parseInt(viewPolicyDetailsByType) - 1, steps)}
                            >
                            {"Previous"}
                            </Button>
                            )}
                        </div>
                        <div className="col-6 text-right">
                            {parseInt(viewPolicyDetailsByType) < 4 && (
                            <Button
                                className="btnCustom"
                                outline
                                color="info"
                                size="md"
                                onClick={(e) => handleNextTabByClick(parseInt(viewPolicyDetailsByType) + 1, steps)}
                            >
                                {"Next"}
                            </Button>
                            )}
                        </div>
                        </div>
                    </div>
                    </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ViewProductModal;
